import { render, staticRenderFns } from "./channel-type-dropdown.vue?vue&type=template&id=3bf36a57&"
import script from "./channel-type-dropdown.vue?vue&type=script&lang=ts&"
export * from "./channel-type-dropdown.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports